import { TokenModel } from "./tokenModel";

export class LoginResponseModel {
    authenticationResult: TokenModel | undefined
    username: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    claims: string[] | undefined;
}